import { UniversalTrackerBlueprintMin, UtrValueType } from '@g17eco/types/universalTracker';
import { canAddTarget, isNumericTableColumnType } from '@utils/universalTracker';

// types that doesn't include value list, table.
export const SIMPLE_TYPES: string[] = [
  UtrValueType.Number,
  UtrValueType.Percentage,
  UtrValueType.Date,
  UtrValueType.Text,
  UtrValueType.Sample,
];

export enum QuestionFilterType {
  Pack = 'pack',
  Subpack = 'subPack',
  Question = 'question',
  Input = 'input',
}

export type ValidatingFunc = (
  question: UniversalTrackerBlueprintMin,
  valueListCode?: string
) => {
  isAllowed: boolean;
  disableReason?: string;
};

// Still show disallowed option but disable it with reason.
export const checkIsNumericInput: ValidatingFunc = (question, valueListCode) => {
  if (!valueListCode) {
    const isAllowed = canAddTarget(question);
    return { isAllowed: true, disableReason: isAllowed ? undefined : 'Not supported' };
  }

  const column = question.valueValidation?.table?.columns?.find((c) => c.code === valueListCode);
  if (!column) {
    return { isAllowed: false };
  }

  const isAllowed = isNumericTableColumnType(column.type);
  return { isAllowed: true, disableReason: isAllowed ? undefined : 'Not supported' };
};
